var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import WasmContext from "./WasmContext";
import { isWasmAvailable } from "./detectWasm";
import { prefillCardInfoCache } from "./util/cachePrefill";
// Helper to make RPC calls to the server
function callRpc(request) {
    return __awaiter(this, void 0, void 0, function () {
        var bodyString, response, errorText, responseText, result, type, responseData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bodyString = JSON.stringify(request);
                    return [4 /*yield*/, fetch("/api/rpc", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: bodyString,
                        })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    errorText = _a.sent();
                    console.error("RPC call failed with status ".concat(response.status, ":"), errorText);
                    console.error("Failed request was:", bodyString);
                    throw new Error("RPC call failed: ".concat(response.statusText));
                case 3: return [4 /*yield*/, response.text()];
                case 4:
                    responseText = _a.sent();
                    try {
                        result = JSON.parse(responseText);
                    }
                    catch (_b) {
                        console.error("Failed to parse JSON response:", responseText);
                        throw new Error("Invalid JSON response from server: ".concat(responseText.substring(0, 100)));
                    }
                    // Check if it's an error response
                    if (result.type === "Error") {
                        throw new Error(result.Error || "Unknown error");
                    }
                    // Since the response uses serde tag="type", the structure is { type: "ResponseType", ...data }
                    // We need to return the whole result minus the type field for most responses
                    // or extract based on the actual response structure
                    if (!result.type) {
                        console.error("Invalid RPC response - missing type field:", result);
                        throw new Error("Invalid RPC response structure");
                    }
                    type = result.type, responseData = __rest(result, ["type"]);
                    // Some responses might be wrapped, others might have the data directly
                    // BatchGetCardInfo should have results directly in responseData
                    return [2 /*return*/, responseData];
            }
        });
    });
}
// Create async versions of each function that can fallback to RPC
var createAsyncFunctions = function (useWasm, wasmModule) {
    if (useWasm && wasmModule) {
        // WASM is available and loaded, use synchronous WASM functions wrapped in promises
        return {
            findViablePlays: function (trump, tractorRequirements, cards) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.find_viable_plays({
                            trump: trump,
                            cards: cards,
                            tractor_requirements: tractorRequirements,
                        }).results];
                });
            }); },
            findValidBids: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.find_valid_bids(req).results];
                });
            }); },
            sortAndGroupCards: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.sort_and_group_cards(req).results];
                });
            }); },
            decomposeTrickFormat: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.decompose_trick_format(req).results];
                });
            }); },
            canPlayCards: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.can_play_cards(req).playable];
                });
            }); },
            explainScoring: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.explain_scoring(req)];
                });
            }); },
            nextThresholdReachable: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    response = wasmModule.next_threshold_reachable(req);
                    return [2 /*return*/, response.reachable];
                });
            }); },
            computeScore: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.compute_score(req)];
                });
            }); },
            computeDeckLen: function (decks) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, wasmModule.compute_deck_len({ decks: decks })];
                });
            }); },
            batchGetCardInfo: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var results;
                return __generator(this, function (_a) {
                    results = req.requests.map(function (r) { return wasmModule.get_card_info(r); });
                    return [2 /*return*/, { results: results }];
                });
            }); },
        };
    }
    else {
        // WASM not available, use RPC calls
        return {
            findViablePlays: function (trump, tractorRequirements, cards) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc({
                                type: "FindViablePlays",
                                trump: trump,
                                tractor_requirements: tractorRequirements,
                                cards: cards,
                            })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.results];
                    }
                });
            }); },
            findValidBids: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "FindValidBids" }, req))];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.results];
                    }
                });
            }); },
            sortAndGroupCards: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "SortAndGroupCards" }, req))];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.results];
                    }
                });
            }); },
            decomposeTrickFormat: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "DecomposeTrickFormat" }, req))];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.results];
                    }
                });
            }); },
            canPlayCards: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "CanPlayCards" }, req))];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.playable];
                    }
                });
            }); },
            explainScoring: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "ExplainScoring" }, req))];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            }); },
            nextThresholdReachable: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "NextThresholdReachable" }, req))];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.reachable];
                    }
                });
            }); },
            computeScore: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "ComputeScore" }, req))];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            }); },
            computeDeckLen: function (decks) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc({
                                type: "ComputeDeckLen",
                                decks: decks,
                            })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.length];
                    }
                });
            }); },
            batchGetCardInfo: function (req) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, callRpc(__assign({ type: "BatchGetCardInfo" }, req))];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response];
                    }
                });
            }); },
        };
    }
};
export var EngineContext = React.createContext(null);
var WasmOrRpcProvider = function (props) {
    var useWasm = isWasmAvailable();
    var _a = React.useState(null), wasmModule = _a[0], setWasmModule = _a[1];
    var _b = React.useState(useWasm), isLoading = _b[0], setIsLoading = _b[1];
    // Load WASM module dynamically if available
    React.useEffect(function () {
        if (useWasm) {
            // Load WASM module dynamically
            import("../shengji-wasm/pkg/shengji-core.js")
                .then(function (module) {
                setWasmModule(module);
                // Set module on window for debugging
                window.shengji = module;
                // WASM module loaded successfully
                setIsLoading(false);
            })
                .catch(function (error) {
                console.error("Failed to load WASM module:", error);
                setIsLoading(false);
            });
        }
        else {
            // Using server-side RPC fallback (no-WASM mode)
            setIsLoading(false);
        }
    }, [useWasm]);
    var engineFuncs = React.useMemo(function () { return createAsyncFunctions(useWasm, wasmModule); }, [useWasm, wasmModule]);
    // Only provide decodeWireFormat in the synchronous context
    var syncContextValue = React.useMemo(function () { return ({
        decodeWireFormat: function (req) {
            if (useWasm && wasmModule) {
                return JSON.parse(wasmModule.zstd_decompress(req));
            }
            else {
                // When WASM is not available, messages should already be decompressed
                // by the server, so we can just parse them directly
                var text = new TextDecoder().decode(req);
                return JSON.parse(text);
            }
        },
    }); }, [useWasm, wasmModule]);
    var engineContextValue = React.useMemo(function () { return (__assign(__assign({}, engineFuncs), { decodeWireFormat: syncContextValue.decodeWireFormat, isUsingWasm: useWasm && wasmModule !== null })); }, [engineFuncs, syncContextValue, useWasm, wasmModule]);
    // Track if initial prefill is complete
    var _c = React.useState(false), isPrefillComplete = _c[0], setIsPrefillComplete = _c[1];
    // Eagerly prefill cache for common trump configurations when engine is ready
    React.useEffect(function () {
        if (!isLoading && engineContextValue && !isPrefillComplete) {
            // Engine ready, eagerly prefill card cache for common trumps
            // Create an array of prefill promises
            var prefillPromises = [];
            // Prefill for NoTrump (used in JoinRoom for the joker cards display)
            var noTrumpBasic = { NoTrump: {} };
            prefillPromises.push(prefillCardInfoCache(engineContextValue, noTrumpBasic)
                .then(function () {
                /* Prefilled cache for NoTrump (no rank) */
            })
                .catch(function (error) {
                return console.error("Failed to prefill NoTrump cache:", error);
            }));
            // Also prefill for NoTrump with rank 2 (most common starting rank)
            var noTrump2 = { NoTrump: { number: "2" } };
            prefillPromises.push(prefillCardInfoCache(engineContextValue, noTrump2)
                .then(function () {
                /* Prefilled cache for NoTrump rank 2 */
            })
                .catch(function (error) {
                return console.error("Failed to prefill NoTrump rank 2 cache:", error);
            }));
            // Wait for all prefills to complete before marking as done
            Promise.all(prefillPromises).then(function () {
                setIsPrefillComplete(true);
                // All initial prefills complete
            });
        }
    }, [isLoading, engineContextValue, isPrefillComplete]);
    // Show loading indicator while WASM is being loaded or initial cache is being prefilled
    if (isLoading) {
        return React.createElement("div", null, "Loading game engine...");
    }
    // Optionally wait for prefill to complete before rendering children
    // This prevents the initial cards from making individual requests
    if (!isPrefillComplete) {
        return React.createElement("div", null, "Initializing game data...");
    }
    return (React.createElement(EngineContext.Provider, { value: engineContextValue },
        React.createElement(WasmContext.Provider, { value: syncContextValue }, props.children)));
};
export default WasmOrRpcProvider;
